export const SetAuthToken=token=>{
    localStorage.setItem("token",token);
}
export const GetAuthToken=()=>{
    return localStorage.getItem("token")
}

export const Redirect_Suppliers="REDIRECT_SUPPLIERS"
export const Redirect_Initial_Companies="REDIRECT_INITIAL_COMPANIES"